export const LINEAR_BASE_ROUTE = 'lin-cai-landing'

export const LINEAR_PATHS = {
    CAI_PRESENTATION_PAGE: "cai_presentation_page",
    WELCOME_FIRST_PAGE: "welcome_first_page",
    FIRMA_DIGITALE_PAGE: "firma_digitale_page",
    QUESTION_AGREEMENT_PAGE: "question_agreement_page",
    SIGNATURE_PROPOSAL_PAGE: "signature_proposal_page",
    REQUIRE_DENUNCIA_PAGE: "require_denuncia_page",
    REQUIRE_DOCUMENTS_PAGE: "require_documents_page",
    OPTIONAL_DOCUMENTS_PAGE: "optional_documents_page",
    RESEND_COMMUNICATION_PAGE: "resend_communication_page",
    LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE: 'realtime_accettazione_cai',
    END_PROCESS_PAGE: "end_process_page",
    END_THANK_YOU_PAGE: "end_thank_you_page",
    END_TO_DRIVER_THANK_YOU_PAGE: "end_to_driver_thank_you_page",
    TOKEN_EXPIRED: "token_expired_page",
    CHOOSE_SIGNATURE_AUTHENTICATION: "choose_signature_authentication"
}
